import { Component } from '@angular/core';
import { AnnouncementBanner } from 'src/app/shared/models/AnnouncementBanner';
import { AnnouncementBannerService } from '../../services/announcement-banner.service';
import { HttpParams } from '@angular/common/http';
import { NgIf } from '@angular/common';
import { GraphicModule } from '../../../graphic/graphic.module';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-announcement-banner',
  imports: [
    NgIf,
    GraphicModule,
    RouterModule
  
],
  templateUrl: './announcement-banner.component.html',
  styleUrl: './announcement-banner.component.scss'
})
export class AnnouncementBannerComponent {

  alert: AnnouncementBanner | null = null;
  showFullDescription = false;

  constructor(private bannerService: AnnouncementBannerService) {

    let searchParams = new HttpParams();
    searchParams = searchParams.append('per_page', '1');
    searchParams = searchParams.append('is_active', '1');

    this.alert = {
      id: "1",
      text: "One careers platform for aviation, construction, engineering, manufacturing, technology & more.",
      long_text: "We’ve brought together several of our sector specific sites including TRS, Aviation Skills Recruitment Platform, Construction Talent Retention Scheme, Talentview Aviation and Talentview Construction. This enables us to provide a better user experience and give you access to all the resources you need to find your perfect job or training opportunities to further your career.",
      mobile_text: "Check out our latest feature that enhances your experience.",
      mobile_long_text: "We’ve brought together several of our sector specific sites including TRS, Aviation Skills Recruitment Platform, Talentview Aviation and Talentview Construction. This enables us to provide a better user experience and give you access to all the resources you need to find your perfect job or training opportunities to further your career.",
      is_active: true
    } as AnnouncementBanner;

    this.bannerService.showOnDesktop();
    this.bannerService.showOnMobile(15000);

    /*this.bannerService.get(searchParams).subscribe(alerts => {
      if(alerts.length) {
        this.alert = alerts[0];

        this.bannerService.showOnDesktop();
        this.bannerService.showOnMobile(15000);
      }
    });*/

    /*this.bannerService.previewAlert.subscribe(alert => {
      if(alert) {
        this.alert = alert;
      }
    });*/

  }

  ngOnInit() {
  }

  closeOnDesktop() {
    this.bannerService.hideOnDesktop();
  }

  closeOnMobile() {
    this.bannerService.hideOnMobile();
  }

  toggleDescription() {
    this.showFullDescription = !this.showFullDescription;
  }
}
